export default "__VITE_ASSET__BhZW7HPo__"